import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=24598c3c&scoped=true"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24598c3c",
  null
  
)

export default component.exports